export default __webpack_public_path__ + "static/media/memoji-1.afa5922f.png";